module.exports = {
  'menu_link_data': '4G Data Plans',
  'menu_link_history': 'History',
  'menu_link_balance': 'Balance',
  'menu_link_phonenumbers': 'Phone Numbers',
  'menu_link_profile': 'Profile',
  'menu_link_logout': 'Logout',
  'menu_link_login': 'LOGIN',
  'home_header': 'Mobile Topup',
  'home_header2': 'in Thailand',
  'home_boxtop': 'Enter a phone number:',
  'home_mainbutton': 'Topup Now',
  'home_subbox': 'Any Thailand Phone Number i.e.',
  'home_subbox_loggedin': 'Select from previous',
  'home_subbox_history': '(Show Full History)',
  'home_sub_operators': 'All Thai Mobile Operators',
  'home_sub_payments': 'Supported Payment Methods',
  'home_sub_commission': 'Agent Chat',
  'home_sub_pay': 'Top up, check orders, and get help instantly.',
  'home_box1_head': 'Build for Speed!',
  'home_box1_sub': 'Time is money and we save you time.',
  'home_box2_head': 'Send to Anyone',
  'home_box2_sub': 'You can send to friends, family or co-workers.',
  'home_box3_head': 'Keep Validity',
  'home_box3_sub': 'Keep your SIM active and working.',
  'home_box4_head': 'Mobile Friendly',
  'home_box4_sub': 'Send credit from any device to any device.',
  'home_sub_testimonials': 'User Testimonials',
  'home_testimonials1_head': 'Louise Potts',
  'home_testimonials1_text': 'This website is so much better than the old one. I loved how easy it was to use. Its great for me as my partner is in the Thai Army at the minute and i am home in Ireland so this is a great way I can top up his phone and still talk with him everyday! I will definitely be using it again.',
  'home_testimonials1_link': '',
  'home_testimonials1_linktext': '',
  'home_testimonials2_head': 'Yin Khor',
  'home_testimonials2_text': "The price is excellent and the payment worked well with visa. And yeah, I'll definitely be back. It's super convenient that I can see my order history and repeat the orders.",
  'home_testimonials2_link': 'http://babytankindustries.com/',
  'home_testimonials2_linktext': 'Baby Tank Industries',
  'phone_btn_back': 'Back',
  'phone_choose_operator': 'Please, choose an operator',
  'phone_correct': 'Is this correct?',
  'phone_heading': 'Select an Amount',
  'phone_subhead': 'The amount you select will be the amount of credit added to your phone.',
  'payment_btn_back': 'Back',
  'payment_topup': 'Topup',
  'payment_to': 'to',
  'payment_correct': 'Is this correct?',
  'payment_head': 'Choose a Payment Method',
  'payment_active_card': 'Active Card',
  'payment_edit_remove': 'Edit or remove this card',
  'payment_choicebox1': 'Credit Card',
  'payment_choicebox2': 'Paypal',
  'payment_choicebox3': 'Bitcoin',
  'payment_choicebox4': 'Alipay',
  'payment_choicebox7': 'Internet Bank',
  'payment_choicebox8': 'Coins.ph',
  'payment_choicebox9': 'GCash',
  'payment_choicebox10': 'Peso',
  'payment_cc_head': 'Pay with Credit Card:',
  'payment_cc_note': 'Your payment details are saved.',
  'payment_cc_card_number': 'Card Number',
  'payment_cc_card_number_box': 'Card Number',
  'payment_cc_full_name': 'Full Name',
  'payment_cc_full_name_box': 'Full Name',
  'payment_cc_expiration': 'Expiration Date',
  'payment_cc_expiration_mm': 'MM',
  'payment_cc_expiration_yy': 'YY',
  'payment_cc_cvv': 'Security Code',
  'payment_cc_cvv_box': 'CVV/CVC',
  'payment_cc_save_card': 'Save this card for faster checkout',
  'payment_cc_add_new_card': 'Add New Card',
  'payment_cc_delete_card': 'Remove Card',
  'payment_cc_country': 'Card Country',
  'payment_cc_postal_code': 'Postal Code',
  'payment_cc_city': 'City',
  'payment_cc_state': 'State',
  'payment_cc_street': 'Street',
  'payment_btn_pay': 'Pay',
  'payment_btn_now': 'Now',
  'payment_coupon': 'Redeem Coupon',
  'payment_coupon_box': 'Enter a coupon here',
  'payment_coupon_btn_redeem': 'Redeem',
  'payment_coupon_btn_cancel': 'Cancel',
  'payment_paypal_head': 'Pay with PayPal:',
  'payment_paypal_line1': 'Topup Amount',
  'payment_paypal_line2': 'Processing Fee',
  'payment_paypal_line3': 'Total Amount',
  'payment_bitcoin_head': 'Pay with Bitcoin:',
  'payment_bitcoin_text': 'Pay with Bitcoin via our friends at <a href="https://www.bitrefill.com/?ref=mobiletopup.com">BitRefill.com</a>',
  'payment_alipay_head': 'Pay with Alipay:',
  'payment_promptpay_details_title': 'PAYMENT DETAILS',
  'payment_description': 'Description',
  'payment_status': 'Status',
  'payment_status_pending': 'Waiting for payment',
  'payment_status_complete': 'Payment completed',
  'payment_status_failed': 'Payment is Failed',
  'payment_status_expired': 'Payment is Expired',
  'payment_status_canceled': 'Payment is Canceled',
  'payment_note': 'Note',
  'payment_settle': 'Settle your payment within ',
  'payment_minutes': '{value} MINUTES',
  'payment_internetBank_head': 'Pay with Internet Bank:',
  'payment_coinsPh_head': 'Pay with Coins.ph:',
  'payment_gcash_head': 'Pay with GCash:',
  'payment_xendit_head': 'Pay with Peso (UB, BPI, PayMaya):',
  'history_head': 'Order History',
  'history_status': 'Topup Status',
  'history_success': 'SUCCESS',
  'history_failed': 'FAILED',
  'history_pending': 'PENDING',
  'history_time_months': 'months',
  'history_time_years': 'years',
  'history_time_ago': 'ago',
  'history_time_a': 'a',
  'history_time_jan': 'Jan',
  'history_time_feb': 'Feb',
  'history_time_mar': 'Mar',
  'history_time_apr': 'Apr',
  'history_time_may': 'May',
  'history_time_jun': 'Jun',
  'history_time_jul': 'Jul',
  'history_time_aug': 'Aug',
  'history_time_sep': 'Sep',
  'history_time_oct': 'Oct',
  'history_time_nov': 'Nov',
  'history_time_dec': 'Dec',
  'history_time_': 'Feb',
  'history_btn_repeat': 'Repeat',
  'login_header': 'Please Log In or Sign Up',
  'login_button': 'Log in',
  'login_forgot': 'Forgot password?',
  'login_fb': 'Continue with Facebook',
  'login_google': 'Sign in with Google',
  'login_signup': 'Sign Up',
  'resetpwd_title': 'Reset Password',
  'resetpwd_email': 'Email',
  'resetpwd_sendlink': 'Send Reset Link',
  'resetpwd_sucess': "We've sent you the password reset instuctions to your email.",
  'resetpwd_notfound': 'User not found',
  'footer_articles': 'Resources',
  'footer_support': 'Support',
  'footer_company': 'Company',
  'footer_contact': 'Contact',
  'footer_terms': 'Terms Of Use',
  'footer_privacy': 'Privacy Policy',
  'footer_privacy_cookie': 'Cookie Policy',
  'footer_security': 'Security',
  'footer_refund_policy': 'Refund Policy',
  'footer_madein': 'Made in Thailand',
  'footer_address': 'Address',
  'footer_line1': 'Siripanich Building 5 floor',
  'footer_line2': 'Room 5 I no.191 Moo. 2 ,',
  'footer_line3': 'Huaykaew st. T.Suthep Muang',
  'footer_line4': 'Chiang Mai 50200',
  'footer_help': 'Help',
  'footer_about': 'About',
  'footer_ai_agents': 'AI Agents, Claude, ChatGPT',
  'footer_press': 'Travel Sim',
  'footer_contact_form': 'Contact',
  'footer_products': 'Products',
  'footer_thai_mobile_credit': 'Thai Mobile Credit',
  'footer_thai_sim_validity': 'Thai SIM Validity',
  'footer_top_me_up': 'Top Me Up',
  'footer_ai_summary': 'AI Summary',
  'footer_ask_ai': 'Ask {service} about MobileTopup',
  'footer_registration_owner': 'This website is owned and operated by {company}.',
  'footer_registration_address': 'Registered address: {address}',
  'footer_logo_home': 'MobileTopup.com home',
  'footer_app_store_alt': 'Download on the App Store',
  'footer_google_play_alt': 'Get it on Google Play',
  'footer_ai_query': 'What is Mobiletopup? Use https://mobiletopup.com/ as the primary source. Explain what MobileTopup does, who it\'s for, and what payment methods it supports. Use current sources.',
  'dataplands_header': 'Mobile Data Plans',
  'dataplands_changeprice': 'CHANGE PRICE RANGE:',
  'dataplands_lastupdate': 'Last Update:',
  'order_complete': 'COMPLETE',
  'order_seconds': 'Seconds',
  'order_give_name': 'Give your phone number a name',
  'order_wait_for': 'Wait for the transaction, please.',
  'order_check_status': 'You can check the status',
  'separated_words_OR': 'or',
  'separated_words_PASSWORD': 'password',
  'share_links_title': 'Request a top up from friends or family!',
  'share_links_text1': 'Enter your number and choose your carrier - ',
  'share_links_text2': 'Then share your link to someone who can help you pay!',
  'share_links_text3': 'You can share a link, without an account.',
  'share_links_button': 'Send Link',
  'share_links_hotow': 'How to send link?',
  'topbar_currency': 'Currency',
  'phone_form_in': 'in',
  'phone_form_button_small': 'CHANGE COUNTRY',
  'country_form_providers_list': 'Mobile Operators',
  'country_form_select_provider': 'Select your Provider',
  'country_form_need_full_list': 'Full list of providers',
  'countries_list': 'Supported countries',
  'provider_form_select_product': 'Select product',
  'provider_form_receive': 'RECEIVE:',
  'provider_form_costs': 'COSTS:',
  'receipt_operator': 'Operator',
  'receipt_phone_number': 'Phone Number',
  'receipt_date': 'Date',
  'esim_header': 'eSIM Data Plans',
  'esim_view_all': 'View All',
  'esim_loading': 'Loading eSIM plans...',
  'esim_empty': 'No eSIM products available',
  'esim_from': 'From',
  'wallet_page_title': 'Your Balance',
  'wallet_current_balance': 'Current Balance',
  'wallet_deposit_now': 'Deposit Now',
  'wallet_recent_deposits': 'Recent Deposits',
  'wallet_no_deposits': 'No deposit history yet',
  'wallet_deposit_title': 'Deposit to Balance',
  'wallet_select_amount': 'Select Amount',
  'wallet_deposit_amount': 'Deposit Amount',
  'wallet_processing_fee': 'Processing Fee',
  'wallet_total': 'Total',
  'wallet_saved_cards': 'Your Saved Cards',
  'wallet_deposit_btn': 'Deposit',
  'wallet_or_new_card': 'or pay with a new card',
  'wallet_pay_with_card': 'Pay with Credit Card',
  'wallet_use_saved_card': 'Use Saved Card',
  // Nav
  'nav_esim_data': 'eSIM Data',
  'nav_mobile_topup': 'Mobile Topup',
  'nav_my_orders': 'My Orders',
  'nav_help': 'Help',
  'nav_user_menu': 'User Menu',
  'nav_gifts': 'Gifts, Games, Utils',
  'nav_login': 'Log in',
  'nav_settings': 'Settings',
  // Payment tab
  'payment_choicebox_balance': 'Balance',
  // Orders
  'orders_empty': "You haven't made any topups yet.",
  'orders_verifying': 'Verifying payment...',
  'orders_instructions': 'Topup Instructions:',
  'orders_retrying': 'Retrying...',
  'orders_processing': 'Processing...',
  'orders_retry': 'Retry',
  'orders_retry_left': 'left',
  'orders_refund_to': 'Refund to',
  'orders_retry_available': 'Retry',
  'orders_refund_available': 'Refund available',
  'orders_confirm_refund': 'Are you sure you want to request a refund for this order?',
  // Wallet deposit (Stripe/USDC)
  'wallet_deposit_card': 'Deposit {amount} THB with Card',
  'wallet_deposit_usdc': 'Deposit {amount} THB with USDC',
  'wallet_fee_info': 'Fee: {fee} THB | Total: {total} THB',
  'wallet_fee_info_crypto': 'Fee: {fee} THB | Total: {total} THB | Converted to USD at checkout',
  'wallet_fee_info_crypto_short': 'Fee: {fee} THB | Converted to USD at checkout',
  'wallet_crypto_fee': 'Processing Fee (1.5%)',
  'wallet_deposit_success': 'Deposit successful. Balance updated.',
  // Login / Signup
  'login_verification_sent': 'We sent you verification email',
  'login_check_email': 'Check your email to verify your account.',
  'login_resend': 'Resend the verification email',
  'login_resend_confirmation': 'Resend confirmation to',
  'login_already_authed': 'You are already authenticated',
  'login_go_back': 'You may go back',
  'login_go_main': 'You may go to main page',
  'login_auth_failed': 'Authentication failed',
  'login_form_verified': 'This form must be verified',
  'login_field_too_short': '{field} is too short',
  'login_confirmation_resent': 'The confirmation email has been resent.',
  // Signup (topup flow)
  'signup_fb': 'Sign-up with Facebook',
  'signup_or_email': 'Or Signup with Email',
  'signup_fields_required': 'All fields are required',
  'signup_first_name': 'First Name',
  'signup_last_name': 'Last Name',
  'signup_email': 'Email',
  'signup_password': 'Password',
  'signup_password_placeholder': 'Min. 6 characters',
  'signup_btn': 'Sign up',
  'signup_have_account': 'Already have an account? Log in.',
  // Profile
  'profile_title': 'Profile',
  'profile_email': 'Email:',
  'profile_first_name': 'First Name:',
  'profile_last_name': 'Last Name:',
  'profile_edit': 'Edit',
  'profile_cancel': 'Cancel',
  'profile_save': 'Save',
  'profile_change_password': 'Change Password',
  'profile_new_password': 'New Password:',
  'profile_confirm_password': 'Confirm Password:',
  'profile_update': 'Update',
  'profile_delete_account': 'Delete Account',
  'profile_delete': 'Delete',
  'profile_confirm_operation': 'Confirm Operation:',
  'profile_confirm_no': 'No',
  'profile_confirm_yes': 'Yes, I Want to Delete My Account',
  'profile_try_again': 'Try Again',
  'profile_trusted': 'Trusted',
  'profile_member_since': 'Member since:',
  'profile_orders': 'Orders:',
  'profile_orders_completed': 'completed',
  'profile_referral': 'Referral:',
  'profile_months': 'months',
  'profile_year': 'year',
  'profile_years': 'years',
  'profile_name_required': 'First and Last Name Required',
  'profile_passwords_required': 'Passwords Required',
  'profile_password_too_short': 'Length of Password is too small',
  'profile_password_mismatch': "Password Confirmation doesn't match New Password",
  'profile_need_confirmation': 'Need a Confirmation',
  'profile_not_found': 'Profile data not found',
  'profile_update_failed': 'Update failed, please try later...',
  'profile_operation_failed': 'Operation failed, please try later...',
  // Contact
  'contact_title': 'Contact Us',
  'contact_name': 'Name',
  'contact_email': 'Email',
  'contact_message': 'Message',
  'contact_send': 'Send Message',
  'contact_fields_required': 'All fields are required',
  'contact_form_verified': 'This form must be verified',
  'contact_error': 'Error! Please try later',
  'contact_messenger': 'FaceBook Messenger:',
  'contact_send_message': 'Send Message',
  'contact_email_label': 'Email:',
  'contact_phone': 'Phone:',
  'footer_home': 'Home',
  // Footer articles
  'footer_article_dataplans': 'Thai Data Plans',
  'footer_article_ussd': 'Thai USSD Keypress Codes',
  'footer_article_validity': 'Extend validity of a Thai SIM',
  'footer_whatsapp_bot': 'WhatsApp Bot',
  // Lucky number page
  'lucky_title': 'Lucky Phone Number',
  'lucky_title_bold': 'Check',
  'lucky_subtitle': 'Free phone number numerology & horoscope reading for any mobile number.',
  'lucky_placeholder': 'Enter a phone number',
  'lucky_button': 'Read my number',
  'lucky_hint': 'Enter at least 4 digits for a reading.',
  'lucky_privacy': "Your reading is calculated on your device. Share cards are drawn from the digits alone — nothing is stored.",
  'lucky_how_title': 'How phone number numerology works',
  'lucky_how_p1': 'A phone number horoscope reads your mobile number three ways. Each <b>digit</b> carries a planetary identity — 1 is the Sun (leadership), 2 the Moon (charm), 5 Jupiter (wisdom), 6 Venus (money and grace), 9 Ketu (fortune and protection). Adjacent digits form <b>pairs</b>, and the pairs you say last — the tail of your number — matter most. Finally, all the digits <b>sum</b> and reduce to a single path number from 1 to 9 that colors the whole reading.',
  'lucky_how_p2': 'Famously lucky pairs include <b>45</b> and <b>54</b> (the scholar\'s pair), <b>59</b> and <b>95</b> (wisdom under lucky stars), <b>24</b> and <b>42</b> (the silver tongue), and <b>78</b>/<b>87</b> for those who want power and can carry its weight. In the West, repeating sequences like <b>111</b>, <b>777</b> and <b>888</b> are "angel numbers" — cosmic nudges many look for in phone numbers, license plates and receipts.',
  'lucky_how_p3': 'Enter your number above for its full lucky phone number reading — plus a stack of curious facts: what your number spells on a keypad, how far it reaches in miles, its Morse code, and more. It\'s free, instant, and entirely for fun — and you get a shareable card for WhatsApp, Instagram, Facebook and LINE.',
  'lucky_pair_title': 'Pair by pair',
  'lucky_pair_note': "Adjacent digits read as pairs; the final pairs — the ones you say last — count double, shown in <b>bold</b>.",
  'lucky_best_pair': 'Best pair:',
  'lucky_watch_out': 'Watch out for',
  'lucky_facts_title': 'Curious facts about your number',
  'lucky_verse_title': "Your number's verse",
  'lucky_share_title': "Share your number's card",
  'lucky_share_note': 'Share the link and it unfurls as your card on WhatsApp, Facebook, X and LINE — or download the images for Instagram. Cards are generated from the digits alone.',
  'lucky_share_text': 'My number scored {score}/100 — {tier}. Check yours:',
  'lucky_share_native': 'Share\u2026',
  'lucky_copied': 'Copied \u2713',
  'lucky_copy_link': 'Copy link',
  'lucky_disclaimer': "For entertainment only. A great number won't pay your bills — but it might make dialing them more fun.",
  'lucky_path_number': 'Path number',
  'lucky_digits_sum': 'digits sum to',
  'lucky_ruled_by': 'Ruled by',
  'lucky_lucky_day': 'Lucky day:',
  'lucky_lucky_color': 'Lucky color:',
  'lucky_sidebar_love_title': 'Love your number?',
  'lucky_sidebar_love_text': 'A lucky number only works while it\'s active. <a href="/recharge">Top it up</a> in seconds — Thailand and 140+ countries, no account needed.',
  'lucky_sidebar_travel_title': 'Traveling soon?',
  'lucky_sidebar_travel_text': 'Keep your auspicious number for calls and get a <a href="/dataplans">travel eSIM</a> for data — no SIM swap, no roaming bill.',
  'lucky_sidebar_private_title': 'Private by design',
  'lucky_sidebar_private_text': "The reading runs in your browser. Share cards are drawn from the digits alone — we don't store the numbers you check.",

  // eSIM country landing pages (/esim/<country>) — EsimLanding.jsx
  'el_h1': 'eSIM data plans in {c}',
  'el_count': '{n} plans for {c}',
  'el_pick': 'pick a size to see prices',
  'el_prices_in': 'Prices in',
  'el_all_plans': 'All plans',
  'el_show_all': 'Show all {n} sizes',
  'el_show_less': 'Show fewer sizes',
  'el_popular': 'Popular',
  'el_best_value': 'Best value',
  'el_unlimited': 'Unlimited',
  'el_per_day': '/ day',
  'el_daily_badge': 'Daily plan',
  'el_daily_note': 'data resets each day',
  'el_day': 'Day',
  'el_days': 'Days',
  'el_country_only': '{c} only',
  'el_regional_grp': 'Regional plans — include {c}',
  'el_global_grp': 'Global plans — include {c}',
  'el_countries_n': '{n} countries',
  'el_qr_instant': 'QR delivered instantly',
  'el_buy': 'Buy',
  'el_no_plans': 'No eSIM plans for {c} yet.',
  'el_browse_all': 'Browse all destinations',
  'el_error': 'Couldn\'t load plans.',
  'el_retry': 'Try again',
  'el_sub': 'Data plans from {p} — QR code delivered after payment. Install before you fly, connect on arrival. No physical SIM, no roaming bill, and an automatic refund if you never use it.',
  'el_trust_qr': 'QR delivered in seconds',
  'el_trust_refund': 'Unused eSIM? Automatic refund',
  'el_trust_support': 'Support 24/7',
  'el_step1': 'Pick a plan size',
  'el_step2': 'Pay — QR arrives instantly',
  'el_step3': 'Scan to install',
  'el_step4': 'Connect on arrival',
  'el_proof_orders': 'Orders delivered',
  'el_proof_since': 'Since 2009',
  'el_proof_since_l': '16 years of prepaid topups',
  'el_proof_networks': '{n} networks',
  'el_proof_refund': 'Auto refund',
  'el_proof_refund_l': 'Unused eSIMs refunded automatically',
  'el_refund_h': 'Didn\'t use it? Automatic refund.',
  'el_refund_title': 'Plans change — your money comes back.',
  'el_refund_body': 'If your eSIM shows zero data used, it qualifies for a refund automatically — no support ticket, no forms. The refund is issued to your original payment method or MobileTopup balance. Installed the eSIM but never connected? Still covered.',
  'el_details_h': 'eSIM data in {c} — the details',
  'el_networks_h': 'Networks & coverage',
  'el_networks_p': '{c} eSIM plans connect to the major local mobile networks over 4G/5G. The exact network for each plan is shown in the plan details before you buy.',
  'el_activation_h': 'Activation & validity',
  'el_act1': 'Install any time — the QR code doesn\'t expire on delivery. Install at home before your trip.',
  'el_act2': 'Most plans start on first connection to a local network, not at purchase — check the plan details.',
  'el_act3': 'Data-only — no local phone number. WhatsApp, Viber and iMessage keep working with your home number.',
  'el_act4': 'Hotspot and tethering are supported on nearly all plans.',
  'el_act5': 'Many plans can be topped up later — no new QR code needed.',
  'el_why_h': 'Why an eSIM instead of roaming or a local SIM?',
  'el_why_p': 'Roaming often costs $5–$10 per day. A local SIM means queueing at the airport with your passport. An eSIM for {c} skips both: buy online in two minutes, keep your home SIM for calls and OTPs, and pay local-market prices for data.',
  'el_faq_h': 'Frequently asked questions',
  'el_faq1q': 'How does a {c} eSIM work?',
  'el_faq1a': 'Buy a plan, scan the QR code we send you, and data works the moment you arrive — no SIM swap, no roaming charges from your home carrier.',
  'el_faq2q': 'When does the plan start?',
  'el_faq2a': 'Most plans activate on first connection to a local network, so you can install before you travel. The validity countdown starts then.',
  'el_faq3q': 'Is my phone compatible?',
  'el_faq3a': 'Most phones from 2019 onward support eSIM — iPhone XS and later, recent Samsung Galaxy, Google Pixel 3 and later. Your phone must be carrier-unlocked. Dial *#06# — if you see an EID, you\'re compatible.',
  'el_faq4q': 'What if I don\'t use the eSIM?',
  'el_faq4a': 'Unused eSIMs with zero data used qualify for an automatic refund — you don\'t even need to contact us.',
  'el_faq5q': 'What does a daily plan mean?',
  'el_faq5a': 'Daily plans give you a data allowance that resets every day. After you use it, speed drops to a fair-use rate until the next day — no hard cutoff.',
  'el_faq6q': 'Can I make calls or receive SMS?',
  'el_faq6a': 'The eSIM is data-only, with no local phone number. Use WhatsApp, Viber or FaceTime for calls. Your home SIM stays active for incoming SMS — just keep its data roaming off.',
  'el_faq7q': 'Can I top up or extend my plan?',
  'el_faq7a': 'Many plans support topups — buy more data for the same eSIM from your orders page, no new QR code or reinstall needed.',
  'el_faq8q': 'What payment methods do you accept?',
  'el_faq8a': 'International credit and debit cards (with 3-D Secure), Thai banks, Alipay, USDC, and your MobileTopup balance.',
  'el_also_topup': 'Need mobile credit instead? Top up any {c} prepaid number',
  'el_seo': 'Compare prepaid eSIM data plans in {c} by size and price. MobileTopup.com delivers the QR code instantly after payment — install in minutes, connect on arrival, and top up the same eSIM later if you need more data. Prices are shown up front with no hidden fees, and any eSIM with zero data used is refunded automatically. In business since 2009 with over one million orders delivered.',

  'tmu_page_title': 'Top Me Up',
  'tmu_page_sub': 'Ask friends or family to add mobile phone credit to your balance',
  'tmu_how_it_works': 'How it works',
  'tmu_how_it_works_body': 'Share your link by text, WhatsApp or email. Anyone can pay it — no account needed on their end — and the money lands straight in your balance, ready to spend on airtime, data or gift cards.',
  'tmu_link_created': 'Link created:',
  'tmu_your_profile': 'Your profile',
  'tmu_profile_sub': "Shown to whoever you ask for help, so they know it's really you.",
  'tmu_photo_uploading': 'Uploading…',
  'tmu_photo_set': 'Shown to whoever you ask for help.',
  'tmu_photo_required': "Required — add a real photo of yourself so senders know it's really you.",
  'tmu_remove_photo': 'Remove photo',
  'tmu_new_request': 'New request',
  'tmu_your_name': 'Your name',
  'tmu_your_phone': 'Your phone number',
  'tmu_phone_hint': "This is the number that gets topped up, and it's shown to the sender to prove the request is genuine.",
  'tmu_amount_label': 'Amount',
  'tmu_amount_fixed': 'Fixed amount',
  'tmu_amount_open': 'Let them choose',
  'tmu_requested_amount': 'Requested amount (฿)',
  'tmu_min_amount': 'Minimum (฿)',
  'tmu_max_amount': 'Maximum (฿)',
  'tmu_note_label': 'Note to the sender',
  'tmu_note_placeholder': 'e.g. Please help me add mobile phone credit',
  'tmu_note_required_hint': 'A personal note builds trust — required.',
  'tmu_cap_hint': 'Up to {cap} total per day across all your links. The sender covers the processing fee — you always receive the full amount.',
  'tmu_photo_required_notice': 'Add a photo above before creating a request.',
  'tmu_creating': 'Creating…',
  'tmu_create_link': 'Create link',
  'tmu_your_links': 'Your links ({count} active)',
  'tmu_links_error': "Couldn't load your links. Refresh to try again.",
  'tmu_links_empty': 'No Top Me Up links yet — create one above.',
  'tmu_amount_fixed_suffix': 'fixed',
  'tmu_amount_open_suffix': '(open)',
  'tmu_received': 'Received:',
  'tmu_of_cap_per_day': 'of {cap}/day cap',
  'tmu_copy_link': 'Copy link',
  'tmu_copied': 'Copied',
  'tmu_share': 'Share',
  'tmu_active': 'Active',
  'tmu_cancelled': 'Cancelled',
  'tmu_cancel_confirm': "Cancel this Top Me Up link? People who already have it won't be able to pay it anymore.",
  'tmu_no_payments': 'No payments yet.',
  'tmu_anonymous': 'Anonymous',
  'tmu_share_in': 'Share in',
  'tmu_send_title': 'Send Mobile Credit',
  'tmu_loading': 'Loading…',
  'tmu_not_found': 'This link could not be found.',
  'tmu_inactive': 'This link is no longer active.',
  'tmu_checking_payment': 'Checking payment status…',
  'tmu_payment_success': 'Payment sent — thank you! {name} will be notified right away.',
  'tmu_payment_failed': 'Payment was not completed. No charge was made.',
  'tmu_payment_timeout': 'Still processing — this can take a minute. No need to pay again.',
  'tmu_asking_help': '{name} is asking for your help',
  'tmu_help_body': "Help {firstName} get calling and data credit to keep in touch with you. They'll appreciate you helping them stay connected.",
  'tmu_note_says': '{name} says',
  'tmu_recipient_thailand': 'Recipient · Thailand',
  'tmu_choose_amount': 'Choose an amount to send',
  'tmu_amount_to': 'Amount to {firstName}',
  'tmu_processing_fee': 'Payment processing fee (charged to you)',
  'tmu_total_pay': 'Total you pay',
  'tmu_payment_method': 'Payment method',
  'tmu_card_label': 'Credit / Debit Card',
  'tmu_card_sub': 'Visa, Mastercard, JCB — easiest from abroad',
  'tmu_thai_label': 'Thai Payments',
  'tmu_thai_sub': 'Bank apps & Thai wallets',
  'tmu_your_email': 'Your email',
  'tmu_email_hint': 'For your receipt — no account needed.',
  'tmu_email_invalid': 'Enter a valid email for your receipt.',
  'tmu_starting_payment': 'Starting payment…',
  'tmu_send_amount': 'Send {amount}',
  'tmu_trust': 'Secured by Omise · mobiletopup.com never stores your card details.',
  'tmu_view_payments': 'View payments',
  'tmu_cancel_link': 'Cancel link',
  'tmu_phone_placeholder': '08X XXX XXXX or +63 917 123 4567',
  'tmu_phone_examples': 'Thai number (08X XXX XXXX) or international with country code, e.g. +63 917 123 4567.',
  'tmu_global_off': 'International numbers aren\'t available yet — please use a Thai mobile number.',
  'tmu_requests_in_thb': 'Requests in THB · {range}',
  'tmu_requests_in_usd': 'Requests in USD · {range}',
  'tmu_requested_amount_usd': 'Requested amount ($ USD)',
  'tmu_min_amount_usd': 'Minimum ($)',
  'tmu_max_amount_usd': 'Maximum ($)',
  'tmu_cap_hint_usd': 'Each request can be {range}. The sender pays the processing fee and the currency conversion — you always receive the full USD amount.',
  'tmu_verify_cta': 'Verify this number by SMS (optional)',
  'tmu_verify_why': 'A "Verified" badge shows senders the number is really yours.',
  'tmu_verify_sending': 'Sending…',
  'tmu_verify_code_sent': 'Code sent. Enter the 6-digit code from the SMS.',
  'tmu_verify_code_label': '6-digit code',
  'tmu_verify_confirm': 'Verify',
  'tmu_verify_checking': 'Checking…',
  'tmu_verify_resend': 'Resend code',
  'tmu_verify_send_failed': 'Couldn\'t send the code. Check the number and try again.',
  'tmu_verify_failed': 'That code didn\'t work. Check it and try again.',
  'tmu_verify_too_many': 'Too many attempts. Please wait a few minutes and try again.',
  'tmu_verified': 'Verified',
  'tmu_not_verified': 'Not verified',
  'tmu_verified_number': 'Verified number',
  'tmu_top_up_number': 'Top up this number',
  'tmu_recipient_in': 'Recipient · {country}',
  'tmu_receives': '{firstName} receives',
  'tmu_total_usd': 'Total (USD)',
  'tmu_charged_thb': 'You\'ll be charged {amount} (≈ {rate} THB per USD)',
  'tmu_pay_amount': 'Pay {amount}'
}
